// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"8dadd05d","230":"3b88a89b","256":"b0d67d49","391":"bc3f4143","728":"b599bbde"}[chunkId] + ".css";
};